'use client';
import React from 'react';
import { withDefaultValues } from '../withDefaultValues';
export const Dot8x8Icon = withDefaultValues((props: React.SVGProps<SVGSVGElement>) => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M16 12a4 4 0 11-8 0 4 4 0 018 0z" fill="currentColor" /></svg>);